import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";
import FloatingBottomNav from "@/components/FloatingBottomNav";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPrompt from "@/components/InstallPrompt";
import RouteTracker from "@/components/RouteTracker";
import { captureAttributionFromURL } from "@/lib/attribution";

import PhoneLogin from "@/pages/PhoneLogin";
import Home from "@/pages/Home";
import Sell from "@/pages/Sell";
import Buy from "@/pages/Buy";
import MyActivity from "@/pages/MyActivity";
import Account from "@/pages/Account";
import LiveOffers from "@/pages/LiveOffers";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";

function App() {
  useEffect(() => {
    // Phase 8.1 — Capture Meta/Google/UTM attribution from the landing URL
    // and stash in sessionStorage so it survives navigation to the sell form.
    captureAttributionFromURL();
    // Service worker registration — only in production builds, only over HTTPS.
    if ("serviceWorker" in navigator && window.location.protocol === "https:") {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .catch((err) => console.warn("SW registration failed:", err));
      });
    }
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/login" element={<PhoneLogin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/sell" element={<ProtectedRoute><Sell /></ProtectedRoute>} />
            <Route path="/buy" element={<Buy />}/>
            <Route path="/activity" element={<ProtectedRoute><MyActivity /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/offers/:vid" element={<ProtectedRoute><LiveOffers /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
          </Routes>
          <FloatingBottomNav />
          <InstallPrompt />
          <Toaster theme="dark" position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
